import React, {FC, useMemo} from 'react';

import {CartItemGlassesTypeV2Type} from '../../types';
import {BaseCartItem} from '../baseCartItem/baseCartItem';
import {CartCollapsibleContent} from '../cartCollapsibleContent/cartCollapsibleContent';
import {CartItemUpgrades} from '../cartItemUpgradesV2/cartItemUpgrades';
import {UpsellFramesConnected} from '../upsellFrames/upsellFrames';
import {UpsellOfferConnected} from '../upsellOffer/upsellOffer';

import s from './cartItemEyeglasses.scss';

type PropsType = {
    item: CartItemGlassesTypeV2Type;
};

/**
 * Cart eyeglasses item
 * @constructor
 */
// eslint-disable-next-line complexity
export const CartItemEyeglasses: FC<PropsType> = ({item}) => {
    const upsellOfferProps = useMemo(
        () => ({
            inStockQty: (item.stock || {}).available_qty,
            itemId: item.id,
            qty: Number(item.qty),
        }),
        [item.qty, item.id, item.stock],
    );

    /**
     * Method for rendering goods with a discount
     * @returns {React.ReactElement} Rendered react component
     */
    const renderOfferFrames = (): React.ReactNode =>
        Array.isArray(item.offerFrames) &&
        item.offerFrames.length > 0 &&
        Number(item.qty) < 2 && (
            <UpsellFramesConnected cartItemID={item.id} offerFrames={item.offerFrames} />
        );

    return (
        <div className={s.item}>
            <div>
                <BaseCartItem item={item}>
                    <CartCollapsibleContent item={item} />
                    <CartItemUpgrades options={item.options} />
                </BaseCartItem>
                {item.upsellData && <UpsellOfferConnected {...upsellOfferProps} />}
            </div>

            {renderOfferFrames()}
        </div>
    );
};
